/**
 * 菜单栏翻译
 **/
export default {
  charts: "Charts",
  collection: {
    generateQRPlate: "Generate QR Code",       // 制作收款码牌
    remoteQR: "Remote Payment QR Code",           // 远程收款码
    title: "Collection"                              // 收款
  },
  complaints: "Consumer Complaints",                 // 消费者投诉
  paymentAnalytics: {
    merchantGroupStats: "Merchant Group Statistics", // 商户组统计
    outletStats: "Outlet Statistics",                  // 营业点统计
    projectStats: "Project Statistics",              // 项目统计
    title: "Payment Analytics"                      // 支付统计
  },
  paymentOrders: {
    downloadOrders: "Download Payment Orders",       // 支付订单下载
    eDocuments: "E-Documents",              // 电子单据
    paymentOrders: "Payment Orders",             // 支付订单
    preAuthOrders: "Pre-authorization Orders",       // 预授权订单
    title: "Payment Orders"                          // 支付订单
  },
  profitSharing: {
    details: "Profit Sharing Details",               // 分账流水
    stats: "Profit Sharing Statistics",              // 分账统计
    title: "Profit Sharing"                          // 分账
  },
  reconciliation: {
    calendar: "Monthly Reconciliation Calendar",     // 对账月历
    details: "Reconciliation Details",               // 对账流水
    downloadData: "Download Reconciliation Data",    // 对账数据下载
    stats: "Reconciliation Statistics",              // 对账统计
    title: "Payment Reconciliation",                         // 支付对账
    uploadStatement: "Upload Bank Statement"         // 上传账单对账
  },
  settings: {
    customColumns: "Custom Column Settings",         // 自定义列设置
    merchantGroupConfig: "Merchant Group Configuration",  // 商户组设置
    outletConfig: "Outlet Configuration",                   // 营业点设置
    projectConfig: "Project Configuration",               // 项目设置
    terminal: "Terminal", // 终端
    title: "Settings"                         // 设置
  },
  settlement: {
    payeeMgmt: "Payee Management",                   // 收款方管理
    payout: "Settlement Payout",                     // 结算打款
    ruleConfig: "Settlement Rule Configuration",     // 结算规则设置
    stats: "Settlement Statistics",                  // 结算统计
    title: "Settlement"                              // 结算
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en/menus.js